import React from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import Item from './Item';

import css from './FilesSection.module.css';

const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

const FilesSection = props => {
  const {
    files,
    label,
    labelClassName,
    value,
    showAsSwiper
  } = props;

  if (!files?.length) {
    return null;
  }

  const screenWidth = typeof window !== 'undefined' && window.innerWidth;
  const slidesToShow = screenWidth && screenWidth < 768 ? 1.3 : 3.3;

  if (showAsSwiper) {
    return (
      <div className={css.wrapper} key={label}>
        <p className={labelClassName}>
          <span className={css.label}>
            {label}
            {!!value && ':'}
          </span>
          {value && <span className={css.value}>{value}</span>}
        </p>

        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: '.custom_next',
            prevEl: '.custom_prev',
          }}
          spaceBetween={10}
          slidesPerView={slidesToShow}
          onSwiper={swiper => { }}
          onSlideChange={() => { }}
        >
          <div className="custom_next">
            <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
          </div>
          <div className="custom_prev">
            <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
          </div>
          <div className={css.documentsWrapper}>
            {!!files?.[0] && files.map(f => {
              return (
                <SwiperSlide key={f?.key}>

                  <Item
                    key={f?.key}
                    file={f}
                  />
                </SwiperSlide>
              );
            })}
          </div>
        </Swiper>
      </div>
    )
  } else {

    return (
      <div className={css.wrapper}>
        <p className={labelClassName}>
          <span className={css.label}>
            {label}
            {!!value && ':'}
          </span>
          {value && <span className={css.value}>{value}</span>}
        </p>
        <div className={css.documentsWrapper}>
          {!!files?.[0] && files.map(f => {
            return (
              <Item
                key={f?.key}
                file={f}
              />
            );
          })}
        </div>
      </div>
    );
  }
};

FilesSection.defaultProps = {
  files: [],
};

export default FilesSection;
